module.exports = __webpack_public_path__ + "img/upload_cell_tall.0f41c78a.gif";